import { render, staticRenderFns } from "./BillingMenu.vue?vue&type=template&id=7c47a28a&scoped=true"
import script from "./BillingMenu.vue?vue&type=script&lang=js"
export * from "./BillingMenu.vue?vue&type=script&lang=js"
import style0 from "./BillingMenu.vue?vue&type=style&index=0&id=7c47a28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47a28a",
  null
  
)

export default component.exports